module.exports = __webpack_public_path__ + "img/Port affairs handling.49b57a79.png";